// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lkry","content":"styles_content__sXnrm"};